export default class LocalStorage {
  constructor(key) {
    const fallbackStorage = {
      getItem: () => null,
      removeItem: () => {},
      setItem: () => {},
    };

    // If for security reason the browser can't access the
    // localStorage we have to provide a Mock to avoid
    // breaking the app.
    try {
      const storage = window.localStorage;

      this.localStorage =
        typeof storage?.getItem === "function" &&
        typeof storage?.removeItem === "function" &&
        typeof storage?.setItem === "function"
          ? storage
          : fallbackStorage;
    } catch (e) {
      console.warn(
        "We can't access the localStorage for security reasons. Please check your browser settings.",
      );
      this.localStorage = fallbackStorage;
    }
    this.key = key;
  }

  getItem(key) {
    if (this.localStorage) {
      return this.localStorage.getItem(this.getKey(key));
    }

    return null;
  }

  getKey(key) {
    return [this.key, key].join("_");
  }

  removeItem(key) {
    if (this.localStorage) {
      this.localStorage.removeItem(this.getKey(key));
    }
  }

  setItem(key, value) {
    if (this.localStorage) {
      this.localStorage.setItem(this.getKey(key), value);
    }
  }
}
